import { useEffect, useState } from "react";
import api from "../../api/axios";

export default function LeaveHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true); // 👈 new loading state

  useEffect(() => {
    const loadHistory = async () => {
      try {
        const res = await api.get("/user/leave/history");
        setHistory(res.data);
      } catch (err) {
        console.error("Failed to load leave history", err);
      } finally {
        setLoading(false); // 👈 hide loader
      }
    };

    loadHistory();
  }, []);

  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold mb-4">Leave History</h1>

      <div className="bg-white shadow rounded-lg overflow-hidden">
        <table className="table-auto w-full">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="p-2">From</th>
              <th className="p-2">To</th>
              <th className="p-2">Remarks</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              // ✅ Table area loading row
              <tr>
                <td colSpan="4" className="text-center py-8">
                  <div className="flex flex-col items-center justify-center">
                    <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-gray-500 mt-3 font-medium">
                      Loading leave history...
                    </p>
                  </div>
                </td>
              </tr>
            ) : history.length === 0 ? (
              // ✅ No data row
              <tr>
                <td colSpan="4" className="text-center py-6 text-gray-500">
                  No leave records found.
                </td>
              </tr>
            ) : (
              // ✅ Normal data rows
              history.map((h, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">
                  <td className="p-2">{h.from_date}</td>
                  <td className="p-2">{h.to_date}</td>
                  <td className="p-2">{h.remarks}</td>
                  <td
                    className={`p-2 font-semibold ${
                      h.status === "Approved"
                        ? "text-green-600"
                        : h.status === "Pending"
                        ? "text-yellow-600"
                        : "text-red-600"
                    }`}
                  >
                    {h.status}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
